import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ContentMasteryTestFailureAttemptRateGauge from './ContentMasteryTestFailureAttemptRateGauge';
import { ContentMasteryFailureAttemptRateListService } from '../../services/ContentListService';
import ContentHistoryService from '../../services/ContentHistoryService';

class ContentMasteryTestFailureAttemptRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    ContentMasteryFailureAttemptRateListService.load();
  }
  render() {
    const data = ContentMasteryFailureAttemptRateListService.getChart();
    return (
      <ContentMasteryTestFailureAttemptRateGauge
        loading={
          ContentMasteryFailureAttemptRateListService.fetchCurrent.fetching ||
          ContentMasteryFailureAttemptRateListService.fetchPrevious.fetching
        }
        currentValue={toJS(data.current)}
        previousValue={toJS(data.previous)}
        formatter={ContentMasteryFailureAttemptRateListService.getFormattedValue}
        onClickHistory={() => ContentHistoryService.openDialog('MASTERY_TEST_ITEM_EXECUTION_FAILURE_ATTEMPT_RATE')}
      />
    );
  }
}

export default observer(ContentMasteryTestFailureAttemptRateGaugeContainer);
